import { Datasheet } from "@/api/datasheets";
import { ParalloyState, StateType } from "./types";
import { ParalloyWeld } from "@/api/paralloy/rbi";
import { Project } from "@/api/project";
import { SubProject } from "@/api/subProject";

export type RbiAction = {
  type: StateType;
  payload?: unknown;
};

export const reducer = (state: ParalloyState, action: RbiAction): ParalloyState => {
  switch (action.type) {
    case "Project":
      return { ...state, project: action.payload as Project, subProject: undefined, datasheet: undefined, welds: [] };
    case "SubProject":
      return { ...state, subProject: action.payload as SubProject, datasheet: undefined, welds: [] };
    case "Datasheet":
      return { ...state, datasheet: action.payload as Datasheet, welds: [] };
    case "Welds":
      return { ...state, welds: action.payload as ParalloyWeld[] };
    default:
      return state;
  }
};
